import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryGrantListModel, SummaryGrantModel } from '../../models/summary-grant.model';


export enum GrantActionTypes {
  LoadGrants = '[Grants Load Grants',
  LoadGrantsSuccess = '[Grants] Load Grants Success',
  LoadGrantsFailure = '[Grants] Load Grants Failure',

  LoadGrant = '[Grant] Load Grant',
  LoadGrantSuccess = '[Grant] Load Grant Success',
  LoadGrantFailure = '[Grant] Load Grant Failure',

  CreateGrant = '[Grant] Create Grant',
  CreateGrantSuccess = '[Grant] Create Grant Success',
  CreateGrantFailure = '[Grant] Create Grant Failure',

  UpdateGrant = '[Grant] Update Grant',
  UpdateGrantSuccess = '[Grant] Update Grant Success',
  UpdateGrantFailure = '[Grant] Update Grant Failure',

  DeleteGrant = '[Grant] Delete Grant',
  DeleteGrantSuccess = '[Grant] Delete Grant Success',
  DeleteGrantFailure = '[Grant] Delete Grant Failure',
}

/** Load all */

export class LoadGrants implements Action {
  readonly type = GrantActionTypes.LoadGrants;
  constructor(public payload: {filter: any}) {}
}

export class LoadGrantsSuccess implements Action {
  readonly type = GrantActionTypes.LoadGrantsSuccess;
  constructor(public payload: { items: SummaryGrantModel[]; total: number; summary: SummaryGrantListModel }) {}
}

export class LoadGrantsFailure implements Action {
  readonly type = GrantActionTypes.LoadGrantsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadGrant implements Action {
  readonly type = GrantActionTypes.LoadGrant;
  constructor(public payload: { uid: string }) {}
}

export class LoadGrantSuccess implements Action {
  readonly type = GrantActionTypes.LoadGrantSuccess;
  constructor(public payload: SingleResponseModel<SummaryGrantModel>) {}
}

export class LoadGrantFailure implements Action {
  readonly type = GrantActionTypes.LoadGrantFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateGrant implements Action {
  readonly type = GrantActionTypes.CreateGrant;
  constructor(public payload: { grant: SummaryGrantModel }) {}
}


export class CreateGrantSuccess implements Action {
  readonly type = GrantActionTypes.CreateGrantSuccess;
  constructor(public payload: { grant: SummaryGrantModel }) {}
}

export class CreateGrantFailure implements Action {
  readonly type = GrantActionTypes.CreateGrantFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateGrant implements Action {
  readonly type = GrantActionTypes.UpdateGrant;
  constructor(public payload: { grant: SummaryGrantModel }) {}
}

export class UpdateGrantSuccess implements Action {
  readonly type = GrantActionTypes.UpdateGrantSuccess;
  constructor(public payload: { grant: SummaryGrantModel }) {}
}

export class UpdateGrantFailure implements Action {
  readonly type = GrantActionTypes.UpdateGrantFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteGrant implements Action {
  readonly type = GrantActionTypes.DeleteGrant;
  constructor(public payload: { uid: string }) {}
}

export class DeleteGrantSuccess implements Action {
  readonly type = GrantActionTypes.DeleteGrantSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteGrantFailure implements Action {
  readonly type = GrantActionTypes.DeleteGrantFailure;
  constructor(public payload: { error: any }) {}
}

export type GrantActions =
  | LoadGrants
  | LoadGrantsSuccess
  | LoadGrantsFailure
  | LoadGrant
  | LoadGrantSuccess
  | LoadGrantFailure
  | CreateGrant
  | CreateGrantSuccess
  | CreateGrantFailure
  | UpdateGrant
  | UpdateGrantSuccess
  | UpdateGrantFailure
  | DeleteGrant
  | DeleteGrantSuccess
  | DeleteGrantFailure
